module.exports = __webpack_public_path__ + "static/wand_of_secrets-48f7af172503a1afbc408b159fbc3130.jpeg";